import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations, LANGUAGES } from "../i18n/translations";
import { pageContent } from "../i18n/pageContent";

const LanguageContext = createContext(null);

const STORAGE_KEY = "site_language";

export function LanguageProvider({ children }) {
  // Sprach-Switcher entfernt — Seite ist fest auf Deutsch.
  const lang = "de";
  const setLang = () => {};

  useEffect(() => {
    document.documentElement.setAttribute("lang", "de");
  }, []);

  const value = useMemo(() => {
    const uiDict = translations.de;
    const contentDict = pageContent.de;
    return {
      lang,
      setLang,
      languages: LANGUAGES,
      t: (key) => uiDict[key] ?? contentDict[key] ?? key,
    };
  }, []);

  return (
    <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
}
